var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-edit-wrapper",
    { attrs: { company: _vm.value } },
    [
      _c("app-company-edit-default", {
        attrs: { value: _vm.value },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }